import loadScript from 'load-script';

import { pay }  from './orderActions';


export const LOAD_ZIP_SCRIPTS_REQUEST = "LOAD_ZIP_SCRIPTS_REQUEST";
export const LOAD_ZIP_SCRIPTS_SUCCESS = "LOAD_ZIP_SCRIPTS_SUCCESS";
export const LOAD_ZIP_SCRIPTS_ERROR = "LOAD_ZIP_SCRIPTS_ERROR";

export const ZIP_CHECKOUT_REQUEST = "ZIP_CHECKOUT_REQUEST";
export const ZIP_CHECKOUT_SUCCESS = "ZIP_CHECKOUT_SUCCESS";
export const ZIP_CHECKOUT_ERROR = "ZIP_CHECKOUT_ERROR";


import config from '../../config';

export const loadScripts = () => {
    return dispatch => {
        dispatch({type: LOAD_ZIP_SCRIPTS_REQUEST});
        loadScript(config('ZIPMONEY_LIBARY_URL'), function (err, script) {
            if (err) {
                dispatch({type: LOAD_ZIP_SCRIPTS_ERROR});
                return
            }
            dispatch({type: LOAD_ZIP_SCRIPTS_SUCCESS});
        })
    };
};

export const checkout = (eventSlug, orderId) => {
    return dispatch => {

        try {
            Zip
                .Checkout
                .init({
                    checkoutUri: `${config('API_URL')}zip-money/checkout?orderId=${orderId}`,
                    redirectUri: '/zipmoney/return',
                    onComplete: (args) => {
                        if (args.state !=="approved"){
                            dispatch({type: ZIP_CHECKOUT_ERROR, error: args.state});
                        }
                        dispatch({type: ZIP_CHECKOUT_SUCCESS, args: args});
                        dispatch(pay(eventSlug, orderId, 'zipmoney', args))
                    },
                    onError: (args) => {
                        console.error(args);
                        dispatch({type: ZIP_CHECKOUT_ERROR, error: err});
                    }
                });
        } catch (err) {
            console.error(err);
            dispatch({type: ZIP_CHECKOUT_ERROR, error: err});
        }
    };
}

